import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=fbc1794a&scoped=true"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc1794a",
  null
  
)

export default component.exports